/* Dreavaya home: "fill a page" builder (tags + pockets → real add to cart) and the order-timeline calendar. */
document.addEventListener('DOMContentLoaded', function () {
  const fmt = (c) => (window.DV && DV.cart ? DV.cart.fmt(c) : (c / 100).toFixed(2));
  const S = window.DV_HOME_STR || {};

  document.querySelectorAll('[data-dv-builder]').forEach((b) => {
    const picks = JSON.parse(b.querySelector('[data-dv-picks]').textContent || '[]');
    const pocketsEl = b.querySelector('[data-dv-pockets]');
    const cta = b.querySelector('[data-dv-builder-add]');
    const tags = Array.from(b.querySelectorAll('[data-dv-tier]'));
    let n = 4;
    const chosen = [0, 1, 2, 3].map((i) => i % Math.max(1, picks.length));
    function draw() {
      tags.forEach((t) => t.setAttribute('aria-pressed', String(+t.dataset.dvTier === n)));
      pocketsEl.innerHTML = [0, 1, 2, 3].map((i) => {
        const p = picks[chosen[i]];
        if (!p) return '';
        const on = i < n;
        return `<button type="button" class="dv-sleeve${on ? '' : ' is-off'}" data-i="${i}" ${on ? '' : 'disabled'} aria-label="${(S.swap || 'Swap design') + ': ' + p.title}"><img src="${p.img}" alt="" loading="lazy"></button>`;
      }).join('');
      const tag = tags.find((t) => +t.dataset.dvTier === n);
      const total = tag ? +tag.dataset.dvTotal : 0;
      cta.textContent = (S.add_n || 'Add these N to cart · P').replace('N', n).replace('P', fmt(total));
    }
    tags.forEach((t) => t.addEventListener('click', () => { n = +t.dataset.dvTier; draw(); }));
    pocketsEl.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-i]'); if (!btn) return;
      const i = +btn.dataset.i; chosen[i] = (chosen[i] + 1) % picks.length; draw();
    });
    cta.addEventListener('click', () => {
      const counts = {};
      chosen.slice(0, n).forEach((k) => { const id = picks[k].id; counts[id] = (counts[id] || 0) + 1; });
      cta.disabled = true;
      DV.cart.add(Object.keys(counts).map((id) => ({ id: +id, quantity: counts[id] })))
        .catch((err) => alert(err.message)).finally(() => { cta.disabled = false; });
    });
    if (picks.length) draw(); else b.querySelector('[data-dv-builder-add]').hidden = true;
  });

  // calendar: today = ordered, +3 business days = shipped, +13 business days after that = arrives (policy: 1–3 + 10–15)
  document.querySelectorAll('[data-dv-cal]').forEach((cal) => {
    const loc = cal.dataset.locale || 'en';
    const notes = (cal.dataset.notes || 'ordered ✓|shipped ✈|it’s here!').split('|');
    const now = new Date(); const y = now.getFullYear(); const m = now.getMonth();
    const addBiz = (d, k) => { const x = new Date(d); while (k > 0) { x.setDate(x.getDate() + 1); if (x.getDay() % 6) k--; } return x; };
    const ship = addBiz(now, 3); const here = addBiz(ship, 13);
    const marks = {};
    const key = (d) => d.getFullYear() + '-' + d.getMonth() + '-' + d.getDate();
    marks[key(now)] = [notes[0], '#4B2B25', '#FBEFE4'];
    marks[key(ship)] = [notes[1], '#A23A0E', ''];
    marks[key(here)] = [notes[2], '#4E7A4F', '#EEF3E6'];
    const showMonth = here.getMonth() !== m && now.getDate() > 20 ? here.getMonth() : m;
    const showYear = showMonth < m ? y + 1 : y;
    const first = new Date(showYear, showMonth, 1); const days = new Date(showYear, showMonth + 1, 0).getDate();
    const lead = (first.getDay() + 6) % 7;
    const wd = Array.from({ length: 7 }, (_, i) => new Date(2024, 0, 1 + i).toLocaleDateString(loc, { weekday: 'short' }));
    let html = wd.map((w) => `<div class="wd">${w.toUpperCase()}</div>`).join('');
    for (let i = 0; i < 35; i++) {
      const dn = i - lead + 1; const ok = dn >= 1 && dn <= days;
      const mk = ok ? marks[showYear + '-' + showMonth + '-' + dn] : null;
      html += `<div class="d" style="background:${mk && mk[2] ? mk[2] : 'transparent'}">${ok ? dn : ''}${mk ? `<span class="dv-hand" style="color:${mk[1]}">${mk[0]}</span>` : ''}</div>`;
    }
    cal.innerHTML = html;
    const label = new Date(showYear, showMonth, 1);
    const wrap = cal.closest('.dv-plan');
    wrap.querySelector('[data-dv-cal-month]').textContent = label.toLocaleDateString(loc, { month: 'long' });
    wrap.querySelector('[data-dv-cal-label]').textContent = label.toLocaleDateString(loc, { month: 'short', year: 'numeric' }).toUpperCase();
  });
});

/* phone: a spread is a binder you can leaf through — the next page sticks out as a named divider tab,
   the bottom corner is dog-eared (it lifts once the first time you reach it), and the page turns about the rings as you swipe */
document.addEventListener('DOMContentLoaded', () => {
  const S = window.DV_HOME_STR || {};
  const phone = matchMedia('(max-width: 989px)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const name = (pg) => { const l = pg.querySelector('.dv-pg__head .dv-label'); return l ? l.textContent.trim() : ''; };
  document.querySelectorAll('.dv-home .dv-spread:not(.dv-spread--stack)').forEach((sp) => {
    const pages = [...sp.querySelectorAll(':scope > .dv-pg')].filter((pg) => getComputedStyle(pg).display !== 'none')
      .sort((a, b) => (+getComputedStyle(a).order) - (+getComputedStyle(b).order));
    if (pages.length < 2) return;
    const box = document.createElement('div'); box.className = 'dv-swipe';
    sp.parentNode.insertBefore(box, sp); box.appendChild(sp);
    const tab = document.createElement('button'); tab.type = 'button'; tab.className = 'dv-swipe__tab'; box.appendChild(tab);
    const ear = document.createElement('span'); ear.className = 'dv-swipe__ear'; ear.setAttribute('aria-hidden', 'true'); box.appendChild(ear);
    const no = document.createElement('div'); no.className = 'dv-swipe__no'; no.setAttribute('aria-live', 'polite'); box.after(no);
    const step = () => pages[1].offsetLeft - pages[0].offsetLeft;
    const cur = () => Math.max(0, Math.min(pages.length - 1, Math.round(sp.scrollLeft / Math.max(1, step()))));
    const go = (i) => sp.scrollTo({ left: Math.min(i * step(), sp.scrollWidth - sp.clientWidth), behavior: reduce ? 'auto' : 'smooth' });
    const place = () => {
      if (!phone.matches) return;
      const k = cur(), last = k === pages.length - 1, pg = pages[k];
      const br = box.getBoundingClientRect(), r = pg.getBoundingClientRect();
      const target = pages[last ? k - 1 : k + 1];
      tab.textContent = name(target) || (last ? (S.prev || 'Back') : (S.next || 'Next'));
      tab.setAttribute('aria-label', (last ? (S.prev || 'Previous page') : (S.next || 'Next page')) + (name(target) ? ': ' + name(target) : ''));
      tab.classList.toggle('is-back', last);
      if (last) { tab.style.left = (r.left - br.left - tab.offsetWidth + 2) + 'px'; tab.style.right = 'auto'; }
      else { tab.style.left = (r.right - br.left - 2) + 'px'; tab.style.right = 'auto'; }
      tab.style.top = (r.top - br.top + r.height * .2) + 'px';
      ear.style.opacity = last ? 0 : 1;
      ear.style.left = (r.right - br.left - ear.offsetWidth) + 'px'; ear.style.top = (r.bottom - br.top - ear.offsetHeight) + 'px';
      no.textContent = 'p. ' + (k + 1) + ' / ' + pages.length;
    };
    // the turning page swings about the rings on its left edge, the one coming in rises a touch
    const turn = () => {
      if (reduce || !phone.matches) return;
      const w = step(), x = sp.scrollLeft;
      pages.forEach((pg, i) => {
        const p = (i * w - x) / w;                       // 0 = in place, -1 = turned away, +1 = next
        const a = p < 0 ? Math.max(-1, p) * 28 : Math.min(1, p) * 6;
        pg.style.transform = Math.abs(a) < .05 ? '' : `perspective(1100px) rotateY(${a.toFixed(2)}deg)`;
      });
    };
    tab.addEventListener('click', () => { const k = cur(); go(k === pages.length - 1 ? k - 1 : k + 1); });
    let raf = 0, t;
    sp.addEventListener('scroll', () => {
      tab.style.opacity = ear.style.opacity = 0;
      if (!raf) raf = requestAnimationFrame(() => { raf = 0; turn(); });
      clearTimeout(t); t = setTimeout(() => { tab.style.opacity = 1; place(); }, 120);
    }, { passive: true });
    addEventListener('resize', place);
    place();
    // first time the spread is well in view: the dog-ear lifts once, as if someone just touched the corner
    if (!reduce && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(([e]) => {
        if (!e.isIntersecting || !phone.matches) return;
        io.disconnect(); place(); ear.classList.add('is-lift');
      }, { threshold: 0.6 });
      io.observe(sp);
    }
  });
});
